export const KEG_ORDER_FULL_DETAILS_LABEL_DELIVERY_ADDRESS = 'Delivery Address'
export const KEG_ORDER_FULL_DETAILS_LABEL_COMMENTS = 'Your Order Comments'
